import { useSelector } from 'react-redux'
import { useEducationFeature } from 'education-tools'
import { cmsEnvironment } from '../selectors'

export default function useCMSEnvironment() {
  const selectedEnvironment = useSelector(cmsEnvironment)
  const feature = useEducationFeature('meg.merchant-portal.contentful-environment')

  if (feature === null) return null

  return selectedEnvironment || (feature && feature.environment) || 'master'
}
